module.exports = __webpack_public_path__ + "img/point-btn.9809fe8d.png";